const Modal = ({ loading,show, onClose, formData, onFinalSubmit }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-sky-200 bg-opacity-50 px-4">
            <div className="bg-white p-5 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-hidden">
                <h2 className="text-xl font-bold mb-4 text-center">Preview Form Data</h2>

                {/* Table Container with Scroll Prevention */}
                <div className="overflow-auto max-h-[60vh]">
                    <table className="w-full border-collapse border border-gray-300 text-sm">
                        <tbody>
                            {Object.entries(formData).map(([key, value]) => (
                                <tr key={key} className="border">
                                    <td className="border px-3 py-2 font-semibold w-1/3">{key.replace(/([A-Z])/g, ' $1').trim()}:</td>
                                    <td className="border px-3 py-2">{value || "N/A"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Buttons */}
                <div className="mt-4 flex justify-end gap-3">
                    <button onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded">
                        Edit
                    </button>
                    <button onClick={onFinalSubmit} className="bg-blue-500 text-white px-4 py-2 rounded">
                    {loading ? "Saving..." : "Save and Next"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
